import { render, staticRenderFns } from "./manipulacaoItensAtivos.vue?vue&type=template&id=250f83fd&class=crud-item-grid"
import script from "./manipulacaoItensAtivos.ts?vue&type=script&lang=js&external"
export * from "./manipulacaoItensAtivos.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('250f83fd')) {
      api.createRecord('250f83fd', component.options)
    } else {
      api.reload('250f83fd', component.options)
    }
    module.hot.accept("./manipulacaoItensAtivos.vue?vue&type=template&id=250f83fd&class=crud-item-grid", function () {
      api.rerender('250f83fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/manipulacaoNew/manipulacaoItensAtivos/manipulacaoItensAtivos.vue"
export default component.exports